export default "__VITE_ASSET__C91GjzsY__"